export const MessageRequestType = {
    Custom: "Custom",
    DebtPaymentNotification: "DebtPaymentNotification"
}
